export enum components {
  repeater = '#repeater1',

  slotButton = '#slotButton',
}
